import { MutationHookOptions, useMutation } from '@apollo/client';

import { ACCEPT_GDPR } from './mutations';

export const useAcceptGdpr = (options?: MutationHookOptions) => useMutation(ACCEPT_GDPR, options);
